// src/App.js
import React from 'react';
import useMeta from '../../hooks/useMeta';

import Navbar from '../../CommonComponent/Navbar/Navbar'; // Importing the Navbar component
import Footer from '../../CommonComponent/Footer/footer';
import NotificationBar from '../../CommonComponent/Notification/NotificationBar';


//page component

import AutomationContent from './PageComponent/AutomationContent'

function Automation() {

    useMeta({
        title: 'With Smart Blinds Control light & privacy with press of remote or phone',
        description: 'Callistus Blinds believe is accessing the high end automation systems in the Smart Blinds for easy and swift light control & make life easier',
        canonical: 'https://callistusblinds.com/automation/',
        og: {
            locale: 'en_US',
            type: 'article',
            title: 'With Smart Blinds Control light & privacy with press of remote or phone',
            description:
                'Callistus Blinds believe is accessing the high end automation systems in the Smart Blinds for easy and swift light control & make life easier',
            url: 'https://callistusblinds.com/automation/',
            site_name: 'Callistus Blinds',
        },
    });

    return (
        <div>
            <Navbar />
            <NotificationBar />
            <AutomationContent />
            <Footer />
        </div>
    );
}

export default Automation;
